var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as __au2ViewDef from './memoria-stone.html';
import { MemoriaStoneModel } from './../models/memoria-stone-model';
import { customElement, bindable } from "aurelia";
let MemoriaStone = class MemoriaStone {
    image() {
        return 'https://talesofcrestoria.fandom.com/wiki/Special:FilePath/' +
            encodeURIComponent(this.stone.name.replace('[', '(').replace(']', ')').replace('é', 'e')) +
            '_(Thumb).png';
    }
};
__decorate([
    bindable,
    __metadata("design:type", MemoriaStoneModel)
], MemoriaStone.prototype, "stone", void 0);
__decorate([
    bindable,
    __metadata("design:type", String)
], MemoriaStone.prototype, "name", void 0);
MemoriaStone = __decorate([
    customElement(Object.assign(Object.assign({}, __au2ViewDef), { name: 'memoria-stone' }))
], MemoriaStone);
export { MemoriaStone };
